import React from 'react';
import { Button } from '../../components/ui/Button';
import { Dialog } from '../../components/ui/Dialog';
import { useLanguage } from '../../lib/i18n';
import { IconTile, type IntegrationEntry } from './IntegrationTiles';

/**
 * Bir entegrasyonun ayrıntı penceresi — hem "Entegrasyonlarım" satırı hem
 * "Keşfet" kartı buraya açılıyor. İçeriği ve alt düğmeleri entegrasyonun
 * kendisi veriyor (IntegrationEntry.body / .footer).
 */
export const IntegrationDetailDialog: React.FC<{ entry: IntegrationEntry | null; onClose: () => void }> = ({
  entry,
  onClose,
}) => {
  const { t } = useLanguage();
  if (!entry) return null;

  return (
    <Dialog
      open
      onClose={onClose}
      title={entry.name}
      description={entry.description}
      footer={
        <>
          {entry.footer}
          <Button variant="secondary" onClick={onClose}>
            {t('Kapat', 'Close')}
          </Button>
        </>
      }
    >
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <IconTile>{entry.icon}</IconTile>
          {entry.badge}
        </div>
        {entry.body}
      </div>
    </Dialog>
  );
};
